/**
 * Timer logic utilities.
 * Pure functions for formatting time and determining urgency state.
 */

/**
 * Formats a time value in seconds to MM:SS string.
 *
 * @param seconds - Total seconds to format (non-negative integer)
 * @returns Formatted string in MM:SS format (e.g., 300 → "05:00")
 */
export function formatTime(seconds: number): string {
 const totalSeconds = Math.max(0, Math.floor(seconds));
 const minutes = Math.floor(totalSeconds / 60);
 const remainingSeconds = totalSeconds % 60;
 const mm = String(minutes).padStart(2, '0');
 const ss = String(remainingSeconds).padStart(2, '0');
 return `${mm}:${ss}`;
}

/**
 * Determines whether the timer is in an urgent state.
 * Urgency is active when 5 minutes (300 seconds) or less remain.
 *
 * @param remainingSeconds - Seconds remaining on the timer
 * @returns true if remaining time is ≤ 300 seconds
 */
export function isUrgent(remainingSeconds: number): boolean {
 return remainingSeconds <= 300;
}
